<template>
  <div class="goods-add" :style="goodsstyle">

    <a-card :bordered="false">

      <a-card title="售后信息" :bordered="false">
        <a-form class="boxs">
          <a-form-item label="商品名称" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
            {{pro.p_name}}
          </a-form-item>

		  <a-form-item label="商品价格" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
			  {{pro.p_price}}
		  </a-form-item>

		  <a-form-item label="商品数量" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
		  	  {{pro.num}}
		  </a-form-item>

		  <a-form-item label="订单号" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
		  	  {{pro.sNo}}
		  </a-form-item>
		  
		  <a-form-item label="发货时间" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
		  	  {{pro.deliver_time}}
		  </a-form-item>
		  
		  <a-form-item label="申请时间" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
		  	  {{pro.re_time}}
		  </a-form-item>

          <a-form-item label="退货类型" :label-col="{ span: 2 }" :wrapper-col="{ span: 14 }">
            {{pro.re_type==1?'退货退款':pro.re_type==2?'仅退款':'换货'}}
          </a-form-item>
		  
		  <a-form-item label="退货状态" :label-col="{ span: 2 }" :wrapper-col="{ span: 14 }">
		    <span style="color:#FF0000">{{getReType(pro)}}</span>
		  </a-form-item>
		  
          <a-form-item label="退款金额" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
            {{pro.re_apply_money}}
          </a-form-item>

          <a-form-item label="退货原因" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
            {{pro.content}}
          </a-form-item>

          <a-form-item label="售后凭证" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
            
            <div class="clearfix">
              <div v-viewer class="imgBox">
                <img :src="item" v-for="(item,index) in imgurls" :key="index" width="100" height="100"  >
              </div>
              
            </div>
            
          </a-form-item>
        </a-form>
      </a-card>
      
    </a-card>
	
	<div class="foot">
	  <a-button type="danger" class="btns" @click="toBack">取消</a-button>
	</div>
	
	<!-- 拒绝 -->
	<a-modal v-model="jujueFlag" title="拒绝理由" :footer="null" width="540px">
			<a-form :form="returnform">
				<a-form-item label="拒绝理由" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
					<a-input
						placeholder="请输入拒绝理由"
						style="width: 295px;"
						v-decorator="['text', { rules: [{ required: true, message: '请输入拒绝理由!' }]}]"
					></a-input>
				</a-form-item>
				<div style="display:flex;justify-content: center;">
					<a-button @click="onGoBack">确认</a-button>
				</div>
			</a-form>
	</a-modal>
	
  </div>
</template>

<script>

export default {
  data() {
    return {
	  returnform: this.$form.createForm(this, { name: 'returnform' }), // 回寄商品form
      goodsstyle:{
        height: '600px',
      },
	  pro:{},
	  imgurls: [],
	  
	  jujueFlag: false
    }
  },
  mounted(){
    
    let content = document.querySelectorAll('.ant-layout-content')[0].offsetHeight
    this.goodsstyle = {
      height: content + 'px'
    }
	
	this.axios()
  },
  methods: {
	  /**
	  * @name 返回
	  * */ 
	  toBack(){
	    this.$router.go(-1)
	  },
	  getReType(record) {
		  if(record.re_type == 1 || record.re_type == 2){
			  if(record.r_type==0 && record.r_type != ''){
				  return '待审核'
			  }else if(record.r_type==1 || record.r_type==3){
				  return '退款中'
			  }else if(record.r_type==11){
				  return '退款成功'
			  }else if(record.r_type==5){
				  return '退款失败'
			  }else if(record.r_type==4 || record.r_type==9 || record.r_type==12){
				  return '退款成功'
			  }else if(record.r_type==2 || record.r_type==8){
				  return '退款失败'
			  } else if (record.r_type == 10) {
				  return '退款失败'
			  }
		  }else if(record.re_type == 3){
			  if(record.r_type==0 && record.r_type != ''){
				  return '待审核'
			  }else if(record.r_type==1 || record.r_type==3){
				  return '换货中'
			  }else if(record.r_type==11){
				  return '换货成功'
			  }else if(record.r_type==5){
				  return '换货失败'
			  }else if(record.r_type==4 || record.r_type==9 || record.r_type==12){
				  return '换货成功'
			  }else if(record.r_type==2 || record.r_type==8){
				  return '换货失败'
			  } else if (record.r_type == 10) {
				  return '换货失败'
			  }
		  }
		  
	  	// if (record.r_status) {
	  	// 	if (record.r_type == 0) {
	  	// 		return '审核中';
	  	// 	} else if (record.r_type == 1 && record.re_type == 3) {
	  	// 		return '同意换货';
	  	// 	} else if(record.r_type == 2 && record.re_type == 3){
	  	// 		return '拒绝换货';
	  	// 	} else if (record.r_type == 1) {
	  	// 		return '同意退货';
	  	// 	} else if (record.r_type == 2) {
	  	// 		return '拒绝退货';
	  	// 	} else if (record.r_type == 3) {
	  	// 		return '待商家收货';
	  	// 	} else if (record.r_type == 4) {
	  	// 		return '同意退款';
	  	// 	} else if (record.r_type == 5) {
	  	// 		return '拒绝并退回商品';
	  	// 	} else if (record.r_type == 8) {
	  	// 		return '拒绝退款';
	  	// 	} else if (record.r_type == 9) {
	  	// 		return '同意并退款';
	  	// 	} else if (record.r_type == 11) {
	  	// 		return '商家寄出商品';
	  	// 	} else if (record.r_type == 12) {
	  	// 		return '售后完成';
	  	// 	} else {
	  	// 		return '售后状态不明';
	  	// 	}
	  	// } else {
	  	// 	if (record.r_type == 4 || record.r_type == 9) {
	  	// 		return '处理成功';
	  	// 	} else if (record.r_type == 11) {
	  	// 		return '审核通过';
	  	// 	} else {
	  	// 		return '已拒绝';
	  	// 	}
	  	// }
	  },
	  axios(){
		  var id = this.$route.params.id
		  
		  this.$request.get('?module=pc_api&action=ReturnGoods&m=view&shop_id=2&id='+id).then(res=>{
		  	this.pro = res.list[0]
			
			let imgurls = []
			res.imgs.filter(item=>{
				if(item){
					imgurls.push(item)
				}
			})
		  	this.imgurls = imgurls
		  })
	  },
    /**
    * @name 拒绝审核
    * */ 
    onGoBack(){
		this.returnform.validateFields((err, values) => {
			if (!err) {
				let id = this.$route.params.id
				var data = {
				    sNo: this.pro.sNo,
				    id: this.$route.params.id,
					user_id:this.pro.user_id,
				}
				data.text = values.text
				if (this.pro.re_type == 1) {
				    data.r_type = 2
				} else if (this.pro.re_type == 2) {
				    data.r_type = 8
				}
				this.$request.post('?module=pc_api&action=ReturnGoods&m=examine',data).then(res=>{
					  if (res.code == 200) {
						 this.$message.success("拒绝成功")
						  setTimeout(()=> {
							  this.axios()
                              this.$router.go(-1)
						  }, 1000)
					  } else {
						 this.$message.warning(res.message)
					  }
					  // 请求完后清空数据并隐藏弹窗
					  this.jujueFlag = false
					  this.returnform.resetFields();

				})
			}
		});
	
    },
	/* 
		通过审核
	 */
      yes(){
          console.log(this.pro)
          let r_type = this.pro.r_type
          let re_type = this.pro.re_type
          if(re_type==1 || re_type==3){
              this.$confirm({
                  title: '提示',
                  content: '确定要通过该用户的申请并让用户寄回?',
                  onOk: () => {
                      var data = {
                          sNo: this.pro.sNo,
                          id: this.$route.params.id,
                          user_id:this.pro.user_id,
                          r_type : 1
                      }
                      this.$request.post('?module=pc_api&action=ReturnGoods&m=examine',data).then(res=>{
                          if (res.code == 200) {
                              this.$message.success("审核通过")
                          }else {
                              this.$message.error("审核失败！")
                          }
                          setTimeout(()=>{
                              this.$router.go(-1)
                          },1500)
                      })
                  }
              });
          }else if(re_type ==  2){
              this.$confirm({
                  title: '提示',
                  content: `确认同意退款，金额为${this.pro.re_apply_money}`,
                  onOk: () => {
                      var data = {
                          sNo: this.pro.sNo,
                          id: this.$route.params.id,
                          user_id:this.pro.user_id,
                          price: this.pro.re_apply_money,
                          r_type : 9
                      }
                      this.$request.post('?module=pc_api&action=ReturnGoods&m=examine',data).then(res=>{
                          if (res.code == 200) {
                              this.$message.success("审核通过")
                          }else {
                              this.$message.error("审核失败！")
                          }
                          setTimeout(()=>{
                              this.$router.go(-1)
                          },1500)
                      })
                  }
              });
          }
      },
  }
};
</script>

<style lang="less" >
.modals {
  .ant-form-item {
    margin-bottom: 0px;
  }

  .boxs {
    display: flex;
    height: 36px;
    min-height: 36px;
    padding-top: 0px;
    align-items: center;
    width: 410px;
    justify-content: space-between;
  }

}
.goods-add {
  height: 100%;
  overflow-y: auto;
  .foot {
    height: 68px;
    width: 100%;
    border-top: 1px solid #e9ecef;
    position: sticky;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0px 60px;
    background: #ffffff;
    z-index: 992;

    .btns {
      margin-right: 10px;
    }
  }

  .ant-card-head {
    position: sticky !important;
    top: 0 !important;
    background: #ffff !important;
    z-index: 991 !important;
  }
}

.boxs {
  padding-top:40px;
  min-height: 400px;
}

.clearfix{
  position: relative;width: 600px;
}
.setMap0,.setMap1,.setMap2,.setMap3,.setMap4{
  position: absolute;bottom: 8px;height: 20px;font-size: 12px;line-height: 20px;text-align: center;width: 104px;background: rgba(0,0,0,0.6);color: #ffffff;z-index: 99;
  cursor: pointer;
}
.setMap0{
  left: 0;background: #2890FF;width: 32px;
}
.setMap1{left: 112px;}
.setMap2{left: 224px;}
.setMap3{left: 336px;}
.setMap4{left: 448px;}

    .imgBox{
        /*width: 104px;*/
        /*height: 104px;*/
        padding: 5px;
        img{
            border: 1px solid #d9d9d9;
            margin: 0 8px 8px 0;
            border-radius: 4px;
        }
    }
</style>